var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper__1",attrs:{"id":"app2"}},[(_vm.isTokenReady)?_c('div',{staticClass:"wrapper__1__content"},[_c('router-view')],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }